const industries = [
  {
    label: 'Auto',
    value: 'Auto',
  },
  {
    label: 'Education',
    value: 'Education',
  },
  {
    label: 'Fitness',
    value: 'Fitness',
  },
  {
    label: 'Healthcare',
    value: 'Healthcare',
  },
  {
    label: 'Hospitality',
    value: 'Hospitality',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export default industries;
